import { GridAction } from '@eforall/dashboard';
import { Accelerator } from '@interfaces';

export function getActions() {

	const actions: GridAction<Accelerator>[] = [];

	return actions;
}